import React, { Component } from 'react';
import { connect } from 'react-redux';

class Loading extends Component {
    //eslint-disable-next-line
    constructor( props ) {
        super( props );
    }

    render() {
        return (
            <div className={`boxLoading ${this.props.hide  ? "hide" : ""} `}>
                <i className="glyphicon glyphicon-refresh spin"></i>   
            </div>
        )
    }


}



// "state" is set in reducers/index.js
function mapStateToProps(state) {
    return {
        //user: state.user
    };
}

export default connect(mapStateToProps)(Loading);